import { useTranslation } from '@mc/i18n'
import { Locations } from '@mc/track-event'

import CTA from 'components/CTA'

import FullImageTile from './FullImageTile'
import BottomImageTile from './BottomImageTile'
import RightImageTile from './RightImageTile'

const ProductExplainer = ({
  titleOverride,
  showCTA = false,
}: {
  titleOverride?: JSX.Element
  showCTA?: boolean
}) => {
  const { t } = useTranslation('@mc/next')

  return (
    <section data-testid='product-explainer' className='mc-py-10'>
      {titleOverride ? (
        <>{titleOverride}</>
      ) : (
        <h2 className='mc-text-h1 mc-text--center mc-mb-9'>
          {t('productExplainer.title')}
        </h2>
      )}
      <div className='row'>
        <div className='col-12 col-md-6 col-lg-8'>
          <FullImageTile
            title={t('productExplainer.sections.content.title')}
            description={t('productExplainer.sections.content.description')}
            imageUrl='https://static.masterclass.com/how_to_compelling_content_optimized.jpg'
          />
        </div>
        <div className='col-12 col-md-6 col-lg-4'>
          <BottomImageTile
            title={t('productExplainer.sections.accessible.title')}
            description={t('productExplainer.sections.accessible.description')}
            imageUrl='https://static.masterclass.com/how_to_accessible_anywhere-optimized.png'
          />
        </div>
        <div className='col-12 col-md-6 col-lg-4'>
          <BottomImageTile
            title={t('productExplainer.sections.instructors.title')}
            description={t('productExplainer.sections.instructors.description')}
            imageUrl='https://static.masterclass.com/Benefits-WorldsBest.png'
          />
        </div>
        <div className='col-12 col-md-6 col-lg-8'>
          <RightImageTile
            title={t('productExplainer.sections.membership.title')}
            description={t('productExplainer.sections.membership.description')}
            imageUrl='https://static.masterclass.com/wyg_membership.png'
          />
        </div>
      </div>
      {showCTA && (
        <div className='mc-pt-3 mc-text--center'>
          <CTA
            trackProps={{
              location: Locations.WHAT_YOU_WILL_GET,
            }}
          />
        </div>
      )}
    </section>
  )
}

export default ProductExplainer
